(() => {
  'use strict';
  for (const form of document.querySelectorAll('[data-email-bridge]')) {
    if (form.dataset.bridgeReady) continue;
    form.dataset.bridgeReady = 'true';
    const button = form.querySelector('[type="submit"]');
    const status = form.querySelector('[data-bridge-status]');
    const success = form.nextElementSibling;
    const originalLabel = button.innerHTML;
    const storageKey = 'bossnet-form-request-' + form.dataset.emailBridge;
    let busy = false;
    let lastRequest;
    const field = name => form.elements.namedItem(name);
    const showError = message => {
      status.textContent = message;
      status.hidden = false;
      status.setAttribute('role', 'alert');
      status.focus({preventScroll: true});
    };
    const snapshot = () => {
      const data = new FormData(form);
      let phone = String(data.get('phone') || '').trim();
      if (phone && !phone.startsWith('+')) phone = String(data.get('phone_prefix') || '+40') + phone.replace(/^0/, '');
      return {
        form: form.dataset.emailBridge,
        ...(form.hasAttribute('data-guided-offer') ? {form_variant:'guided-v1',goals:data.getAll('goals'),has_site:String(data.get('has_site') || ''),budget:String(data.get('budget') || '')} : {}),
        name: String(data.get('name') || '').trim(), county: String(data.get('county') || '').trim(),
        company: String(data.get('company') || '').trim(), email: String(data.get('email') || '').trim(),
        phone, subject: String(data.get('subject') || '').trim(), message: String(data.get('message') || '').trim(),
        site_url: form.hasAttribute('data-guided-offer') && data.get('has_site') !== 'Da' ? '' : String(data.get('site_url') || '').trim(), ads_active: String(data.get('ads_active') || ''),
        details: String(data.get('details') || '').trim(), services: data.getAll('services'),
        ...(form.hasAttribute('data-guided-offer') ? {} : {privacy_consent: data.has('privacy_consent')}), website: String(data.get('website') || ''),
        page: location.origin + location.pathname
      };
    };
    form.addEventListener('input', event => {
      event.target.removeAttribute('aria-invalid');
      event.target.setCustomValidity?.('');
      const errorId = event.target.dataset.bridgeErrorId;
      if (errorId) {
        document.getElementById(errorId)?.remove();
        const remaining = (event.target.getAttribute('aria-describedby') || '').split(' ').filter(id => id !== errorId).join(' ');
        if (remaining) event.target.setAttribute('aria-describedby', remaining);
        else event.target.removeAttribute('aria-describedby');
        delete event.target.dataset.bridgeErrorId;
      }
      status.hidden = true;
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || form.hidden) return;
      if (form.bossnetGuided) {if (!form.bossnetGuided.beforeSubmit()) return;}
      else if (!form.reportValidity()) return;
      const data = snapshot();
      if (data.form === 'offer' && !data.services.length) {
        const picker = form.querySelector('.ut-services details');if(picker)picker.open = true;
        form.dispatchEvent(new CustomEvent('bossnet:form-error', {detail:{category:'validation'}}));
        showError('Selectează cel puțin un serviciu.');
        form.querySelector('[name="services"]').focus();
        return;
      }
      busy = true;
      const controls = [...form.elements].map(element => [element, element.disabled]);
      controls.forEach(([element]) => { element.disabled = true; });
      button.textContent = 'Se trimite…';
      form.setAttribute('aria-busy', 'true');
      status.hidden = true;
      let controller;
      let timeout;
      let failureCategory = 'response';
      try {
        const bytes = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(JSON.stringify(data)));
        const fingerprint = [...new Uint8Array(bytes)].map(byte => byte.toString(16).padStart(2, '0')).join('');
        let stored = lastRequest;
        try { stored = JSON.parse(sessionStorage.getItem(storageKey)) || stored; } catch {}
        const id = stored?.fingerprint === fingerprint ? stored.id : crypto.randomUUID();
        lastRequest = {id, fingerprint};
        try { sessionStorage.setItem(storageKey, JSON.stringify(lastRequest)); } catch {}
        controller = new AbortController();
        timeout = setTimeout(() => controller.abort(), 65000);
        const response = await fetch(form.dataset.endpoint, {
          method: 'POST', mode: 'cors', credentials: 'omit', signal: controller.signal,
          headers: {'Content-Type': 'application/json', 'X-Bridge-Key': form.dataset.bridgeKey},
          body: JSON.stringify({...data, request_id: id})
        });
        failureCategory = response.ok ? 'response' : 'server';
        const result = await response.json();
        if (!response.ok || result.ok !== true || result.request_id !== id) {
          if (result.errors && typeof result.errors === 'object') {
            form.bossnetGuided?.showServerErrors(result.errors);
            for (const [name, message] of Object.entries(result.errors)) {
              const input = field(name);
              if (input?.setCustomValidity) {
                input.setCustomValidity(String(message));
                input.setAttribute('aria-invalid', 'true');
                const errorId = input.id + '-bridge-error';
                let inlineError = document.getElementById(errorId);
                if (!inlineError) {
                  inlineError = document.createElement('span');
                  inlineError.id = errorId;
                  inlineError.className = 'bn-bridge-field-error';
                  (input.closest('.ut-field') || input.parentElement).append(inlineError);
                }
                inlineError.textContent = String(message);
                input.dataset.bridgeErrorId = errorId;
                const ids = new Set((input.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
                ids.add(errorId);
                input.setAttribute('aria-describedby', [...ids].join(' '));
              }
            }
          }
          throw new Error(result.message || 'Nu am putut confirma trimiterea. Reîncearcă sau sună la 0755 861 343.');
        }
        form.dispatchEvent(new CustomEvent('bossnet:lead-success', {bubbles: true, detail: {requestId: id}}));
        form.hidden = true;
        form.bossnetGuided?.success();
        success.hidden = false;
        success.focus({preventScroll: true});
        success.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'});
        try { sessionStorage.removeItem(storageKey); } catch {}
      } catch (error) {
        const category = error.name === 'AbortError' ? 'timeout' : error instanceof TypeError ? 'network' : failureCategory;
        form.dispatchEvent(new CustomEvent('bossnet:form-error', {detail:{category}}));
        form.bossnetGuided?.failed();
        // Reuse the stored identifier for retries, including after an uncertain network response.
        showError(error instanceof TypeError || error instanceof SyntaxError || error.name === 'AbortError'
          ? 'Conexiunea s-a întrerupt și nu putem confirma trimiterea. Datele au rămas completate. Poți reîncerca verificarea sau suna la 0755 861 343.'
          : error.message);
      } finally {
        clearTimeout(timeout);
        controls.forEach(([element, disabled]) => { element.disabled = disabled; });
        button.innerHTML = originalLabel;
        form.removeAttribute('aria-busy');
        busy = false;
      }
    });
    button.disabled = false;
  }
})();
